import React from 'react'

import UserAvatar, { AvatarableUser } from '@/components/misc/UserAvatar'
import {
  AvatarGroup,
  AvatarGroupCount,
  AvatarSize,
} from '@/components/ui/avatar'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

interface Props {
  users: AvatarableUser[]
  maxUsersToShow?: number
  size?: AvatarSize
  /** When provided, hovering the strip reveals this content */
  tooltip?: React.ReactNode
}

const UserAvatarsStrip: React.FC<Props> = ({
  users,
  maxUsersToShow = 5,
  size = 'lg',
  tooltip,
}) => {
  const strip = (
    <AvatarGroup>
      {users.slice(0, maxUsersToShow).map((user, index) => (
        <UserAvatar key={index} user={user} size={size} />
      ))}

      {users.length > maxUsersToShow && (
        <AvatarGroupCount>+{users.length - maxUsersToShow}</AvatarGroupCount>
      )}
    </AvatarGroup>
  )

  if (!tooltip) {
    return strip
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{strip}</TooltipTrigger>

      <TooltipContent side="top">{tooltip}</TooltipContent>
    </Tooltip>
  )
}

export default UserAvatarsStrip
